// extracted by mini-css-extract-plugin
module.exports = {"html":"DefaultHtmlStyling_html__B6_Yj"};